export enum ESignupFormSteps {
  email = 'email',
  password = 'password',
  emailConfirm = 'emailConfirm',
  personalDetails = 'personalDetails',
  last = 'last',
}
